module.exports = __webpack_public_path__ + "static/media/logo-colored.0ecdac28.png";